'use client'

import { useEffect, useState } from 'react'
import './ScrollToTop.css'

/** Fixed “back to top” control — sits above the Elfsight chat FAB on the right. */
export default function ScrollToTop() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 280)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  if (!visible) return null

  return (
    <button
      type="button"
      className="scroll-to-top"
      aria-label="Scroll to top"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <svg className="scroll-to-top__icon" viewBox="0 0 24 24" aria-hidden="true">
        <path
          fill="currentColor"
          d="M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z"
        />
      </svg>
    </button>
  )
}
